/**
 * @file main.jsx
 * Entry point dell'applicazione React.
 * Se VITE_MOCK_API=true, avvia il service worker MSW prima di montare l'app,
 * permettendo lo sviluppo offline con dati in-memory.
 */

import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import App from './App';

async function bootstrap() {
  if (import.meta.env.VITE_MOCK_API === 'true') {
    const { worker } = await import('./mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: { url: '/mockServiceWorker.js' },
    });
    console.info('[MSW] Mock API attivo — dati in-memory');
  }

  createRoot(document.getElementById('root')).render(<App />);
}

bootstrap();
